import {Month} from './import_csv';
import {addQuarters, endOfQuarter, isAfter, isBefore, isSameDay, startOfYear, subYears} from 'date-fns';

export function toQuarters(months: Month[], referenceDate: Date) {
    const startOfCurrentYear = startOfYear(referenceDate);

    const quarters = [0, 1, 2, 3].map((quarter) => {
        const startDateOfQuarter = addQuarters(startOfCurrentYear, quarter);

        return {
            quarter: quarter,
            history: [2, 1, 0].map((years) => {
                const startDateOfHistoryQuarter = subYears(startDateOfQuarter, years);
                const endDateOfHistoryQuarter = endOfQuarter(startDateOfHistoryQuarter);
                const monthsInQuarter = months.filter(
                    (month) =>
                        (isAfter(month.date, startDateOfHistoryQuarter) ||
                            isSameDay(month.date, startDateOfHistoryQuarter)) &&
                        isBefore(month.date, endDateOfHistoryQuarter),
                );

                return {
                    date: startDateOfHistoryQuarter,
                    months: monthsInQuarter,
                    revenue: monthsInQuarter.reduce((p, c) => p + c.revenue, 0),
                    cost: monthsInQuarter.reduce((p, c) => p + c.cost, 0),
                    result: monthsInQuarter.reduce((p, c) => p + c.result, 0),
                };
            }),
        };
    });

    return quarters;
}
